import { render, staticRenderFns } from "./GlobalApiChangesExampleDI.vue?vue&type=template&id=f7f7acce&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports